module.exports = __webpack_public_path__ + "static/img/KZ.3089abc9.jpg";